// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["core","jquery"], () => (__webpack_require__("./node_modules/lazysizes/lazysizes.js")))
__webpack_require__.O(undefined, ["core","jquery"], () => (__webpack_require__("./node_modules/picturefill/dist/picturefill.js")))
__webpack_require__.O(undefined, ["core","jquery"], () => (__webpack_require__("./node_modules/jquery/dist/jquery.js?8828")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["core","jquery"], () => (__webpack_require__("./src/patterns/index.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
